const headerMedium = () => import('@/components/headerMedium/index');
const header = () => import('@/components/header/index');
const userHome = () => import('@/views/lottery/userHome.vue');//首页
const logistics = () => import('@/views/lottery/logistics');//物流
const marketing = () => import('@/views/lottery/marketing');//营销活动
const stationInfo = () => import('@/views/lottery/stationInfo');//网点信息
const openWinner = () => import('@/views/lottery/openWinner');//开奖信息
// const majorPerson = () => import('@/views/lottery/majorPerson');//专管员信息
const myApply = () => import('@/views/lottery/myApply');//我的申请
const marketList = () => import('@/views/lottery/marketList');//营销活动
const active = () => import('@/views/lottery/active');//调查问卷
const activeList = () => import('@/views/lottery/activeList');//调查问卷
const consumables = () => import('@/views/lottery/consumables');//耗材申领
const temp = () => import('@/views/temp');//
// const crame = () => import('@/views/demoCamera');//调研拍照加人像框
const medium = () => import('@/views/lottery/medium');//语音小助手屏保播放管理
const hdmiMedium = () => import('@/views/lottery/hdmiMedium');//HDMI大屏管理
// const videoView = () => import('@/views/lottery/videoView');//

export default [

    {
        path: '/userHome',
        name: 'userHome',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '首页',
        },
        components: {
            default: userHome,
            // header:header
        }
    },{
        path:'/logistics',
        name: 'logistics',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '物流查询',
        },
        components: {
            default: logistics,
            header:header
        }
    },{
        path:'/marketing',
        name: 'marketing',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '营销活动',
        },
        components: {
            default: marketing,
            header:header
        }
    },{
        path:'/stationInfo',
        name: 'stationInfo',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '网点信息',
        },
        components: {
            default: stationInfo,
            header:header
        }
    },{
        path:'/openWinner',
        name: 'openWinner',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '开奖信息',
        },
        components: {
            default: openWinner,
            header:header
        }
    },
    // {
    //     path:'/majorPerson',
    //     name: 'majorPerson',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '专管员信息',
    //     },
    //     components: {
    //         default: majorPerson,
    //         header:header
    //     }
    // },
    {
        path:'/myApply',
        name: 'myApply',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '我的申请',
        },
        components: {
            default: myApply,
            header:header
        }
    },{
        path:'/marketList',
        name: 'marketList',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '体验券核销记录',
        },
        components: {
            default: marketList,
            header:header
        }
    },{
        path:'/active',
        name: 'active',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '调查问卷',
        },
        components: {
            default: active,
            header:header
        }
    },{
        path:'/activeList',
        name: 'activeList',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '调查问卷',
        },
        components: {
            default: activeList,
            header:header
        }
    },{
        path:'/consumables',
        name: 'consumables',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '热敏纸申领',
        },
        components: {
            default: consumables,
            header:header
        }
    },{
        path:'/temp',
        name: 'temp',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: 'temp',
        },
        components: {
            default: temp,
            // header:header
        }
    },{
        path:'/medium',
        name: 'medium',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '媒体机管理',
        },
        components: {
            default: medium,
            header:headerMedium
        }
    },{
        path:'/hdmiMedium',
        name: 'hdmiMedium',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: 'HDMI大屏管理',
        },
        components: {
            default: hdmiMedium,
            header:headerMedium
        }
    }
    // ,{
    //     path:'/videoView',
    //     name: 'videoView',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: '媒体机管理',
    //     },
    //     components: {
    //         default: videoView,
    //         header:header
    //     }
    // }
    // {
    //     path:'/crame',
    //     name: 'crame',
    //     meta: {
    //         keepAlive: true,
    //         login: true,
    //         iconLeft:true,
    //         title: 'crame',
    //     },
    //     components: {
    //         default: crame,
    //         // header:header
    //     }
    // }
];
